import { OPEN_MODAL } from '../actionTypes';
import { actions } from '../reducer';

export default (value) => actions[OPEN_MODAL](value);
